export function Footer({ className }) {
  const current_date = new Date();

  return (
    <footer
      className={`py-2 bg-primary ${className} min-h-[50px] flex items-center justify-center`}
    >
      <div className="h-full flex-col md:flex-row flex gap-8 text-white font-light font-helvetica text-base justify-center items-center">
        <p className="flex justify-center items-center">© Avanci AI {current_date.getFullYear()}</p>

        <p className="flex justify-center items-center">Todos os direitos reservados</p>
      </div>
    </footer>
  );
}
